<template>
  <v-card
    elevation="9"
    class="template-card"
  >
    <v-card-title class="card-title-text pb-1">
      {{ title }}
    </v-card-title>

    <v-card-text class="px-xs-only-4">
      <slot>
        <new-document-template-category-description
          v-if="description"
        >
          {{ description }}
        </new-document-template-category-description>
        <v-data-table
          :items="templates"
          :search="search"
          :disable-sort="true"
          smaller
          hide-default-footer
          :headers="headers"
          :disable-pagination="expanded"
          :items-per-page="templateItemsPerPage"
          class="no-hover transparent"
          :mobile-breakpoint="0"
          :hide-default-header="true"
        >
          <template #[`item`]="{ item }">
            <tr class="clickable">
              <td
                class="pl-0 pr-2"
                :class="{preview: item.preview}"
                @click="selectTemplate(item)"
              >
                {{ item.name }}
                <v-chip
                  v-if="item.preview"
                  class="ml-2"
                  x-small
                >
                  Request
                </v-chip>
              </td>
            </tr>
          </template>

          <template #footer>
            <v-row>
              <v-col>
                <v-btn
                  color="primary"
                  outlined
                  :disabled="templates.length <= templateItemsPerPage"
                  small
                  @click="expanded = !expanded"
                >
                  {{ expanded ? 'See less' : 'See all' }}
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </slot>
    </v-card-text>
  </v-card>
</template>

<script>
import NewDocumentTemplateCategoryDescription from './NewDocumentTemplateCategoryDescription.vue'

export default {
  name: 'NewDocumentTemplateList',
  components: {
    NewDocumentTemplateCategoryDescription
  },
  props: {
    title: { type: String, required: true },
    description: { type: String, default: '' },
    templates: { type: Array, required: true },
    search: { type: String, default: '' }
  },
  data: () => ({
    expanded: false,
    templateItemsPerPage: 3,
    headers: [{ text: '', value: 'name', width: '100%' }]
  }),
  methods: {
    selectTemplate(template) {
      this.$emit('templateSelected', template)
    }
  }
}
</script>

<style lang="scss" scoped>
.clickable {
  cursor: pointer;
}
.template-card {
  min-height: 260px;
}
.preview {
  color: var(--v-slategray-base)
}
</style>
